import React from 'react';

import { twMerge } from 'tailwind-merge';

import Skeleton from 'components/skeleton/skeleton';

interface KanbanCardSkeleton {
  className?: string;
}

const KanbanCardSkeleton: React.FC<KanbanCardSkeleton> = (props) => {
  return (
    <div
      className={twMerge(
        'flex flex-col justify-between w-full',
        'rounded-lg shadow-6',
        props.className,
      )}
    >
      <Skeleton className="w-full h-24" />
    </div>
  );
};

export default KanbanCardSkeleton;
